import React from 'react';
import { TableHead } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS } from 'utils/constants/dashboard';

type CapacityManagementDrillDownTableHeaderProps = {
  handleSort: (column: string) => void;
};

const CapacityManagementDrillDownTableHeader: React.FC<
  CapacityManagementDrillDownTableHeaderProps
> = ({ handleSort }) => {
  const headCells = [
    {
      'data-cy': 't-header__Request',
      columnName: CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.NAME,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.NAME'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.USER_TYPE,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.USER_TYPE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TASK_NUMBER,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.TASK_NUMBER'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TASK_TITLE,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.TASK_TITLE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TASK_STATUS,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.TASK_STATUS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TASK_TYPE,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.TASK_TYPE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.ALLOCATED_HOURS,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.ALLOCATED_HOURS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.ACTUAL_HOURS,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.ACTUAL_HOURS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROJECT_TITLE,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT_TITLE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.BUSINESS_UNITS,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.BUSINESS_UNITS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROGRAMS,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.PROGRAMS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROJECT_TEAMS,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT_TEAMS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName:
        CAPACITY_MANAGEMENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.USER_TEAMS,
      content: intl.get(
        'DASHBOARDS_CAPACITY_MANAGEMENT_DRILLDOWN_PAGE.TABLE.HEAD.USER_TEAMS'
      ),
    },
  ];

  return (
    <TableHead stickyHeader handleSort={handleSort} headCells={headCells} />
  );
};

export default CapacityManagementDrillDownTableHeader;
